import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=36e123b0&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=36e123b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e123b0",
  null
  
)

export default component.exports